import { Pipe, PipeTransform } from '@angular/core';
import { StatusImportacaoMovimentacaoCadastral } from 'src/app/core/models/movimentacao-cadastral/StatusImportacaoMovimentacaoCadastral';

@Pipe({
  name: 'badgeStatusMovimentacao',
})
export class BadgeStatusMovimentacaoPipe implements PipeTransform {
  transform(status: StatusImportacaoMovimentacaoCadastral): string {
    const labels = {
      0: 'danger',
      1: 'primary',
      2: 'warning text-dark',
      3: 'success',
    };

    return labels[status];
  }
}
